import { Head, Link, usePage } from '@inertiajs/react'
import CollectSession from './collect_session'
import { CollectSessionType } from './types'

interface ShowProps {
  collect_session: CollectSessionType
}

export default function Show({ collect_session }: ShowProps) {
  const { flash } = usePage()

  return (
    <>
      <Head title={`Collect session #${collect_session.id}`} />

      <div className="mx-auto md:w-2/3 w-full px-8 pt-8">
        <div className="mx-auto">
          {flash.notice && (
            <p className="py-2 px-3 bg-green-50 mb-5 text-green-500 font-medium rounded-lg inline-block">
              {flash.notice}
            </p>
          )}

          <h1 className="font-bold text-4xl">Collect session #{collect_session.id}</h1>

          <CollectSession collect_session={collect_session} />

          <Link
            href={`/collect_sessions/${collect_session.id}/edit`}
            className="mt-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
          >
            Edit this collect session
          </Link>
          <Link
            href="/collect_sessions"
            className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
          >
            Back to collect sessions
          </Link>
          <div className="inline-block ml-2">
            <Link
              href={`/collect_sessions/${collect_session.id}`}
              as="button"
              method="delete"
              className="mt-2 rounded-lg py-3 px-5 bg-gray-100 font-medium"
            >
              Destroy this collect session
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}
